import { pageContent } from "./siteData";

export const editablePages = ["about", "technology", "roadmap", "leadership"];

export function defaultPageContent(pageKey) {
  const source = pageContent[`/${pageKey}`];
  return {
    eyebrow: source.eyebrow,
    title: source.title,
    intro: source.intro,
    sections: source.sections.map(([heading, body]) => ({ heading, body })),
  };
}